import './filters-menu.scss';
import moment, { Moment } from 'moment';
import { Dispatch, RefObject, SetStateAction, useEffect, useRef, useState } from 'react';
import Streams from './streams';
import Dates from './dates';
import AccessToken from 'components/app/project/access-token';
import { useClickOutside } from 'hooks/click-outside';
import { useQuery } from 'hooks/query';
import { useHistory } from 'react-router-dom';

function FiltersMenu({
    open,
    setOpen,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    streamIds,
    setStreamIds,
    projectTypeId,
    showDatePicker,
    buttonRef,
    dateRangeComparison
}: {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
    dateFrom: moment.Moment,
    setDateFrom: Dispatch<SetStateAction<moment.Moment>>,
    dateTo: moment.Moment,
    setDateTo: Dispatch<SetStateAction<moment.Moment>>,
    streamIds: number[],
    setStreamIds: Dispatch<SetStateAction<number[]>>,
    projectTypeId: number,
    showDatePicker: boolean,
    buttonRef: RefObject<HTMLElement>;
    dateRangeComparison?: () => void
}) {
    const ref= useRef<any>();
    const query = useQuery();
    const history = useHistory();
    const [accessTokenModalOpen, setAccessTokenModalOpen] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<Moment>(moment(query.get('datefrom')));
    const [stopDate, setStopDate] = useState<Moment>(moment(query.get('dateto')));
    const [streamIdList, setStreamIdList] = useState<number[]>([]);

    useClickOutside([ref, buttonRef], () => setOpen(false));
    
    const quickDateSelect = (val: number) => {
        switch (val) {
            case 1:
                setStartDate(moment().set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 2: 
                setStartDate(moment().subtract(1, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment().set('hours', 0).set('minutes', 0).set('seconds', 0).subtract(1, 'second'));
                break;
            case 3: 
                setStartDate(moment().subtract(1, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 4: 
                setStartDate(moment().subtract(6, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 5: 
                setStartDate(moment().subtract(13, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 6: 
                setStartDate(moment().subtract(29, 'day').set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 7: 
                setStartDate(moment().set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment());
                break;
            case 8: 
                setStartDate(moment().subtract(1, 'month').set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0));
                setStopDate(moment().set('date', 1).set('hours', 0).set('minutes', 0).set('seconds', 0).subtract(1, 'second'));
                break;
        }
    }

    const toggleStream = (id: number) => {
        if (id === 10 && !streamIdList.includes(10)) {
            setStreamIdList([10]);
        } else if (id !== 10 && streamIdList.includes(10)) {
            setStreamIdList([id]);
        } else {
            if (streamIdList.includes(id)) {
                setStreamIdList(streamIdList.filter(x => x !== id));
            } else {
                setStreamIdList([
                    ...streamIdList,
                    id
                ])
            }
        }
    }

    const openAccessTokenModal = () => {
        setOpen(false);
        setAccessTokenModalOpen(true);
    }

    const submit = () => {
        query.set('datefrom', startDate.format("YYYY-MM-DD"));
        query.set('dateto', stopDate.format("YYYY-MM-DD"));
        query.set('streams', streamIdList.join(','));
        history.replace({
            search: `?${query.toString()}`
        })
        setDateFrom(startDate);
        setDateTo(stopDate.hour(23).minute(59).second(59));
        setStreamIds(streamIdList);
        setOpen(false);
    }

    useEffect(() => {
        const streams = query.get('streams')!.split(',').map(x => parseInt(x));
        if (streams.length === 1 && streams[0] === 10) {
            setStreamIdList([10]);
            setStreamIds([10]);
        } else {
            setStreamIdList(streams.filter(x => x !== 10));
            setStreamIds(streams.filter(x => x !== 10));
        }
    }, [query, setStreamIds])

    return (
        <>
            <div className={`filters-menu ${open ? 'open' : ''}`} ref={ref}>
                {showDatePicker && (
                    <div className="filters-menu-section date">
                        <p className="filters-menu-section-heading">Date Range</p>
                        <Dates dateFrom={startDate} setDateFrom={setStartDate} dateTo={stopDate} setDateTo={setStopDate} quickDateSelect={quickDateSelect} />
                    </div>
                )}
                <div className="filters-menu-section streams">
                    <p className="filters-menu-section-heading">Streams</p>
                    <Streams streamIds={streamIdList} toggleStream={toggleStream} projectTypeId={projectTypeId} />
                </div>
                <div className="filters-menu-section buttons">
                    <div className="filters-menu-section-body">
                        <button className="btn-date-range-comparison" onClick={dateRangeComparison}>Date Range Comparison</button>
                        <button onClick={openAccessTokenModal}>Manage Access Tokens</button>
                    </div>
                </div>
                <button className="submit" onClick={submit}>Submit</button>
            </div>
            <AccessToken open={accessTokenModalOpen} setOpen={setAccessTokenModalOpen} />
        </>
    )
}

export default FiltersMenu;